webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = __webpack_require__(43);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(41);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(40);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(71);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _App = __webpack_require__(24);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Dashboard = __webpack_require__(31);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	
	var router = new _vueRouter2.default({
	  mode: 'hash',
	  linkActiveClass: 'active',
	  routes: [{ path: '/dashboard', component: _Dashboard2.default }, { path: '*', component: _Dashboard2.default }]
	});
	
	new _vue2.default((0, _extends3.default)({
	  router: router
	}, _App2.default)).$mount('#app');

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SmallMenu = __webpack_require__(29);
	
	var _SmallMenu2 = _interopRequireDefault(_SmallMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      menus: [{
	        url: '/',
	        text: '动画',
	        num: 100,
	        items: [{ url: '/', text: 'MAD·AMV' }, { url: '/', text: 'MMD·3D' }, { url: '/', text: '短片·手书·配音' }, { url: '/', text: '综合' }]
	      }, {
	        url: '/',
	        text: '番剧',
	        num: 58,
	        items: [{ url: '/', text: '连载动画' }, { url: '/', text: '完结动画' }, { url: '/', text: '国产动画' }, { url: '/', text: '资讯' }, { url: '/', text: '官方延伸' }, { url: '/', text: '新番时间表' }, { url: '/', text: '番剧索引' }]
	      }, {
	        url: '/',
	        text: '国创',
	        num: 58,
	        items: [{ url: '/', text: '国产动画' }, { url: '/', text: '国产原创相关' }, { url: '/', text: '布袋戏' }, { url: '/', text: '资讯' }, { url: '/', text: '新番时间表' }, { url: '/', text: '国产动画索引' }]
	      }, {
	        url: '/',
	        text: '音乐',
	        num: 764,
	        items: [{ url: '/', text: '原创音乐' }, { url: '/', text: '翻唱' }, { url: '/', text: 'VOCALOID·UTAU' }, { url: '/', text: '演奏' }, { url: '/', text: '三次元音乐' }, { url: '/', text: 'OP/ED/OST' }, { url: '/', text: '音乐选集' }]
	      }, {
	        url: '/',
	        text: '舞蹈',
	        num: 110,
	        items: [{ url: '/', text: '宅舞' }, { url: '/', text: '三次元舞蹈' }, { url: '/', text: '舞蹈教程' }]
	      }, {
	        url: '/',
	        text: '游戏',
	        num: '999+',
	        items: [{ url: '/', text: '单机联机' }, { url: '/', text: '网游·电竞' }, { url: '/', text: '音游' }, { url: '/', text: 'Mugen' }, { url: '/', text: 'GMV' }]
	      }, {
	        url: '/',
	        text: '科技',
	        num: 659,
	        items: [{ url: '/', text: '纪录片' }, { url: '/', text: '趣味科普人文' }, { url: '/', text: '野生技术协会' }, { url: '/', text: '演讲·公开课' }, { url: '/', text: '星海' }, { url: '/', text: '数码' }, { url: '/', text: '机械' }]
	      }, {
	        url: '/',
	        text: '生活',
	        num: 885,
	        items: [{ url: '/', text: '搞笑' }, { url: '/', text: '日常' }, { url: '/', text: '美食圈' }, { url: '/', text: '动物圈' }, { url: '/', text: '手工' }, { url: '/', text: '绘画' }, { url: '/', text: '运动' }]
	      }, {
	        url: '/',
	        text: '鬼畜',
	        num: 93,
	        items: [{ url: '/', text: '鬼畜调教' }, { url: '/', text: '音MAD' }, { url: '/', text: '人力VOCALOID' }, { url: '/', text: '教程演示' }]
	      }, {
	        url: '/',
	        text: '时尚',
	        num: 203,
	        items: [{ url: '/', text: '美妆' }, { url: '/', text: '服饰' }, { url: '/', text: '健身' }, { url: '/', text: '资讯' }]
	      }, {
	        url: '/',
	        text: '广告',
	        num: 28,
	        items: [{ url: '/', text: '其实我没有' }]
	      }, {
	        url: '/',
	        text: '娱乐',
	        num: 773,
	        items: [{ url: '/', text: '综艺' }, { url: '/', text: '明星' }, { url: '/', text: '韩流相关' }]
	      }, {
	        url: '/',
	        text: '影视',
	        num: 993,
	        items: [{ url: '/', text: '电影' }, { url: '/', text: '电视剧' }]
	      }],
	      onlines: [{ url: '/', text: '萌宅推荐' }, { url: '/', text: '手机直播' }, { url: '/', text: '绘画专区' }, { url: '/', text: '唱见舞见' }, { url: '/', text: '御宅文化' }, { url: '/', text: '生活娱乐' }, { url: '/', text: '单机联机' }, { url: '/', text: '网络游戏' }, { url: '/', text: '电子竞技' }, { url: '/', text: '手游直播' }, { url: '/', text: '放映厅' }]
	    };
	  },
	
	  props: {
	    logo: {
	      type: String,
	      default: ''
	    },
	    bg: {
	      type: String,
	      default: ''
	    },
	    title: {
	      type: String,
	      default: 'bilibili'
	    },
	    url: {
	      type: String,
	      default: ''
	    }
	  },
	  components: {
	    SmallMenu: _SmallMenu2.default
	  }
	};

/***/ },
/* 11 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      now: 0,
	      pre: '',
	      next: '',
	      lists: [[{
	        url: 'http://www.bilibili.com/video/av6809843',
	        title: '【魔道祖师】《在下名叫蓝忘机》by花千诚',
	        img: 'http://i2.hdslb.com/bfs/archive/3ebf7f39aeec3b188ad4962ed49983fd21d1bedb.jpg@320w_200h.webp',
	        up: 'up主：横夏',
	        play: '播放：124354'
	      }, {
	        url: 'http://www.bilibili.com/video/av6812091',
	        title: '【凡大王】第3期 万圣节装扮，你准备好了吗？朋克小恶魔/哥特萝莉/蒸朋女巫',
	        img: 'http://i2.hdslb.com/bfs/archive/7404bc4b8e23b94d9fc5add53fb6cd03328140f1.jpg@320w_200h.webp',
	        up: 'up主：梵凡凡大王',
	        play: '播放：175820'
	      }, {
	        url: 'http://www.bilibili.com/video/av6822693',
	        title: '【诸葛魔琴】新空城计',
	        img: 'http://i0.hdslb.com/bfs/archive/5ff58d39f259e06c63d2b8ee5e1985f3dcc9fb88.jpg@320w_200h.webp',
	        up: 'up主：OELoop',
	        play: '播放：195900'
	      }, {
	        url: 'http://www.bilibili.com/video/av6822527',
	        title: '看完这个视频我就又玩游戏去了',
	        img: 'http://i1.hdslb.com/bfs/archive/3748dc5548eb91699f44857248fb2099a97e74d0.jpg@320w_200h.webp',
	        up: 'up主：史丹利Studio',
	        play: '播放：412454'
	      }, {
	        url: 'http://www.bilibili.com/video/av6818987/',
	        title: '[中日歌词] 天际与心扉都会雨过天晴 - Aqours (二年级)',
	        img: 'http://i1.hdslb.com/bfs/archive/294c9b6c3e562896e49daf684d7154b24b360f27.jpg@320w_200h.webp',
	        up: 'up主：南條小鹿',
	        play: '播放：25879'
	      }, {
	        url: 'http://www.bilibili.com/video/av6822817/',
	        title: '「偶像梦幻祭」组合歌曲CD 第2弾 vol.03 Knights',
	        img: 'http://i1.hdslb.com/bfs/archive/de4f874a60cd43d5fa4a32eee9a4c4e9d1adbc9d.jpg@320w_200h.webp',
	        up: 'up主：苍红☆将M抖到底',
	        play: '播放：11576'
	      }, {
	        url: 'http://www.bilibili.com/video/av6814878',
	        title: '【欣欣】久保由利香summer chance翻跳( •̀∀•́ )',
	        img: 'http://i2.hdslb.com/bfs/archive/d89ccd927dc188921f8471940090c1a78ded6191.jpg@320w_200h.webp"',
	        up: 'up主：欣欣是个大兄控ww',
	        play: '播放：44087'
	      }, {
	        url: 'http://www.bilibili.com/video/av6812487',
	        title: '【翻填】非洲人的NNRR一直下【阴阳师爆肝魂歌】NL不分/阿睿/狩觞',
	        img: 'http://i1.hdslb.com/bfs/archive/9fc96a55c25e30dea7fc68b0d21e55824e1a54aa.jpg@320w_200h.webp',
	        up: 'up主：喵草鞋veravi',
	        play: '16392'
	      }], [{
	        url: 'http://www.bilibili.com/video/av6749717',
	        title: '【米优手书】My Pretty Teddy【百夜优一郎2016生诞祭】终结的炽天使',
	        img: 'http://i0.hdslb.com/bfs/archive/c2d6547c6d2c78d7faafc7de2a9bef97c804a731.jpg@320w_200h.webp',
	        up: 'up主：百夜米迦勒',
	        play: '播放：48544'
	      }, {
	        url: 'http://www.bilibili.com//video/av6750386',
	        title: '[AMV]仅此一次的迷恋',
	        img: 'http://i1.hdslb.com/bfs/archive/db961c2557f9f874b743408e135a126de0d0da09.jpg@320w_200h.webp',
	        up: 'up主：Cola141',
	        play: '播放：93416'
	      }, {
	        url: 'http://www.bilibili.com/video/av6766853',
	        title: '【多素材/节奏向/抽帧系/AMV】486燃烧的综漫梦',
	        img: 'http://i2.hdslb.com/bfs/archive/58d05ed48aec27d5320509281a2db479f95c54ca.jpg@320w_200h.webp',
	        up: 'up主：真德万万',
	        play: '播放：84165'
	      }, {
	        url: 'http://www.bilibili.com/video/av6764164',
	        title: '【言和·洛天依·乐正绫】颓坠【原创曲·野良犬P】',
	        img: 'http://i1.hdslb.com/bfs/archive/eb66d42aca24d2113ca3eb50c93571014ed1fdbb.jpg@320w_200h.webp',
	        up: 'up主：skm',
	        play: '播放：44118'
	      }, {
	        url: 'http://www.bilibili.com/video/av6752867',
	        title: '【Fate kaleid liner】卫宫士郎的回答',
	        img: 'http://i2.hdslb.com/bfs/archive/c3ac9b3a796514f60dd5a50a27953ce70cef38ee.jpg@320w_200h.webp',
	        up: 'up主：AA8',
	        play: '播放：89143'
	      }, {
	        url: 'http://www.bilibili.com/video/av6765172',
	        title: '【狂风桑】极乐肾宝【极乐净土】',
	        img: 'http://i1.hdslb.com/bfs/archive/499973782edbe17a67a70827218cb8b9a7568a27.jpg@320w_200h.webp',
	        up: 'up主：狂风桑',
	        play: '播放：290866'
	      }, {
	        url: 'http://www.bilibili.com/video/av6753239',
	        title: '【全明星RAP】一人我饮酒醉',
	        img: 'http://i0.hdslb.com/bfs/archive/841225c0e27e0b17c71f351c559e064693cb5141.jpg@320w_200h.webp',
	        up: 'up主：一咸菊菊',
	        play: '播放：612607'
	      }, {
	        url: 'http://www.bilibili.com/video/av6783826',
	        title: '【时之歌Project】【原创曲】孤帆【小坠】',
	        img: 'http://i2.hdslb.com/bfs/archive/10b24ef477eab8feb9f8cd53c84113a12d0513f0.jpg@320w_200h.webp',
	        up: 'up主：时之歌Project',
	        play: '103842'
	      }], [{
	        url: 'http://www.bilibili.com/video/av6834776/',
	        title: '【KBShinya】剑阁来客',
	        img: 'http://i0.hdslb.com/bfs/archive/fc1d3d14545ae25754a7a5b79375d0088ab7a90c.jpg@320w_200h.webp',
	        up: 'up主：KBShinya',
	        play: '24997'
	      }, {
	        url: 'http://www.bilibili.com/video/av6833022',
	        title: '【洛洛烘焙坊】教你做进击的巨人主题蛋挞 @柚子木字幕组',
	        img: 'http://i1.hdslb.com/bfs/archive/ad057138a969a9a1b1294e9a94a2adcbd51ada10.jpg@320w_200h.webp',
	        up: 'up主：柚子木字幕组',
	        play: '播放：14121'
	      }, {
	        url: 'http://www.bilibili.com/video/av6836427/',
	        title: '【电音金坷垃】Pneumatic Tokyo - Env——有些节奏就是让人欲罢不能！',
	        img: 'http://i2.hdslb.com/bfs/archive/70d60eaee3231730489e90094d7a2567cf4f87d9.jpg@320w_200h.webp',
	        up: 'up主：别惹精神病',
	        play: '播放：5362'
	      }, {
	        url: 'http://www.bilibili.com/video/av6840246/',
	        title: '【刘醒  梁非凡】Beat it',
	        img: 'http://i1.hdslb.com/bfs/archive/03dd3ed21624558b786fd1de4c418505d331126b.jpg@320w_200h.webp',
	        up: 'up主：绿豆KC',
	        play: '播放：9481'
	      }, {
	        url: 'http://www.bilibili.com/video/av6835341/',
	        title: '【初音ミクx鏡音リン】帰路奇譚【犬丸芝居小屋】',
	        img: 'http://i2.hdslb.com/bfs/archive/a4e24d8d2377a530bbf18723e535c81fbbbac979.jpg@320w_200h.webp',
	        up: 'up主：MENたいこ/一十',
	        play: '播放：641'
	      }, {
	        url: 'http://www.bilibili.com/video/av6837910/',
	        title: '【作死物理小讲堂】无线充电器骗局揭秘 @FPS罗兹 灵魂字幕',
	        img: 'http://i1.hdslb.com/bfs/archive/b402f440741df144e40079923244458bfb309280.jpg@320w_200h.webp',
	        up: 'up主：罗兹',
	        play: '播放：22831'
	      }, {
	        url: 'http://www.bilibili.com/video/av6837630/',
	        title: '【木鱼微剧场】几分钟看完《李献计历险记》',
	        img: 'http://i1.hdslb.com/bfs/archive/ae881eec2b90da248810e3410a41029b531d1787.jpg@320w_200h.webp',
	        up: 'up主：木鱼水心',
	        play: '播放：31564'
	      }, {
	        url: 'http://www.bilibili.com/video/av6835340/',
	        title: '【MMD镜头配布】弱音唯美向婚纱-Soleil【2016MMD配布向】',
	        img: 'http://i0.hdslb.com/bfs/archive/ebeadde8491bb09649a44d3d4120672399d46abe.jpg@320w_200h.webp',
	        up: 'up主：哟不正',
	        play: '1244'
	      }]]
	    };
	  }
	};

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      index: 0,
	      set: '',
	      url: '',
	      name: ''
	    };
	  },
	
	  watch: {
	    index: function index() {
	      this.name = this.carousels[this.index].name;
	      this.url = this.carousels[this.index].url;
	    },
	    carousels: function carousels() {
	      this.name = this.carousels[this.index].name;
	      this.url = this.carousels[this.index].url;
	    }
	  },
	  props: {
	    carousels: {
	      type: Array,
	      default: function _default() {
	        return [{
	          name: '',
	          url: ''
	        }];
	      }
	    }
	  },
	  methods: {
	    go: function go(i) {
	      this.index = i;
	    },
	    end: function end() {
	      clearInterval(this.set);
	    },
	    start: function start() {
	      var _this = this;
	
	      this.set = setInterval(function () {
	        if (_this.carousels.length > 0) {
	          _this.index = _this.index >= _this.carousels.length - 1 ? 0 : _this.index += 1;
	        }
	      }, 5000);
	    }
	  },
	  mounted: function mounted() {
	    this.start();
	  },
	  destroyed: function destroyed() {
	    this.end();
	  }
	};

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      nowItem: -1,
	      navTop: 232,
	      nowTop: 0
	    };
	  },
	
	  props: {
	    lists: {
	      type: Array,
	      default: []
	    },
	    offsetTop: {
	      type: Number,
	      default: 0
	    },
	    left: {
	      type: Number,
	      default: 0
	    },
	    drap: {
	      type: Boolean,
	      default: false
	    }
	  },
	  methods: {
	    updateNav: function updateNav() {
	      var _this = this;
	
	      if (this.lists[0].top) {
	        this.nowTop = window.scrollY;
	        this.lists.every(function (item, index) {
	          if (_this.nowTop < item.top - _this.offsetTop) {
	            _this.nowItem = index - 1;
	            return false;
	          } else {
	            if (index === _this.lists.length - 1) {
	              if (_this.nowTop >= item.top - _this.offsetTop && _this.nowTop < item.top + item.height) {
	                _this.nowItem = _this.lists.length - 1;
	                return false;
	              } else {
	                _this.nowItem = _this.lists.length;
	                return true;
	              }
	            } else {
	              _this.nowItem = -1;
	              return true;
	            }
	          }
	        });
	      }
	    },
	    navClick: function navClick(top, index) {
	      this.nowItem = index;
	      this.goScroll(top);
	    },
	    goScroll: function goScroll(top) {
	      var _this2 = this;
	
	      var requestAnimationFrame;
	      if (window.requestAnimationFrame) {
	        requestAnimationFrame = window.requestAnimationFrame;
	      } else {
	        requestAnimationFrame = setTimeout(function (fn) {
	          fn();
	        }, 17);
	      }
	
	      var t = 0;
	
	      var b = window.scrollY;
	
	      var c = top - b;
	
	      var d = 20;
	      var step = function step() {
	        var v = _this2.run(t, b, c, d);
	
	        window.scrollTo(0, v);
	        t += 1;
	        if (t <= d) {
	          requestAnimationFrame(step);
	        }
	      };
	      step();
	    },
	    run: function run(t, b, c, d) {
	      return c * (t /= d) * t + b;
	    },
	    changeDraps: function changeDraps() {
	      this.$emit('updateDrap', !this.drap);
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.updateNav();
	    if (window.scrollY > 200) {
	      this.navTop = 50;
	    } else {
	      this.navTop = 232;
	    }
	    window.onscroll = function () {
	      _this3.updateNav();
	      if (window.scrollY > 200) {
	        _this3.navTop = 50;
	      } else {
	        _this3.navTop = 232;
	      }
	    };
	  }
	};

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['items']
	};

/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      set: 0,
	      showImg: '',
	      ranks: [{
	        url: 'http://bh3.biligame.com/yuyue/',
	        text: '崩坏3',
	        img: 'http://i0.hdslb.com/bfs/game/cbab91ba8981913b894c74433eee5ebfdd80910b.png'
	      }, {
	        url: 'http://ntdgm.biligame.com/yuyue.html',
	        text: '那兔之大国梦',
	        img: 'http://i0.hdslb.com/bfs/game/c0d223aa39c4a2ad9a9e201399fb2c6109eb3538.png'
	      }, {
	        url: 'http://sdmht.biligame.com/yuyue.html',
	        text: '神代梦华谭',
	        img: 'http://i0.hdslb.com/bfs/game/6b138b68d4bcb75c486ffa7e592970298e659c29.png'
	      }, {
	        url: 'http://tank.biligame.com/yuyue.html',
	        text: '装甲联盟',
	        img: 'http://i0.hdslb.com/bfs/game/82d16f654bfcc27f728bc8a8e9fb193310484eee.png'
	      }, {
	        url: 'http://kfq.biligame.com/yuyue/',
	        text: '少女咖啡枪',
	        img: 'http://i0.hdslb.com/bfs/game/0f38471ed9f2260a6625fc3df1cf947994be1541.png'
	      }, {
	        url: 'http://madoka.biligame.com/yuyue.html',
	        text: '魔法少女小圆',
	        img: 'http://i0.hdslb.com/bfs/game/c776546e88a6c2ddf6d5c3fc1bab388ea4154ddd.png'
	      }, {
	        url: 'http://hywz.biligame.com/yuyue.html',
	        text: '幻影纹章',
	        img: 'http://i0.hdslb.com/bfs/game/59d24a99226e9d1d273708b1a78452c811bf0aa9.png'
	      }]
	    };
	  },
	
	  props: {
	    bg: {
	      type: String,
	      default: ''
	    },
	    light: {
	      type: Number,
	      default: 0
	    }
	  },
	  computed: {
	    lights: function lights() {
	      var top = this.light === 0 ? 'white' : 'black';
	      return top;
	    }
	  },
	  methods: {
	    show: function show(img) {
	      document.querySelector('.imgdiv').style.background = 'url(' + img + ')';
	    },
	    leave: function leave() {
	      document.querySelector('.imgdiv').style.background = '';
	    },
	    hasClass: function hasClass(all, name) {
	      var arr = all.split(' ');
	      var has = false;
	      arr.forEach(function (val) {
	        if (val === name) {
	          has = true;
	        }
	      });
	      return has;
	    }
	  }
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TopNav = __webpack_require__(30);
	
	var _TopNav2 = _interopRequireDefault(_TopNav);
	
	var _BgNav = __webpack_require__(25);
	
	var _BgNav2 = _interopRequireDefault(_BgNav);
	
	var _Mcarousel = __webpack_require__(27);
	
	var _Mcarousel2 = _interopRequireDefault(_Mcarousel);
	
	var _Lcarousel = __webpack_require__(26);
	
	var _Lcarousel2 = _interopRequireDefault(_Lcarousel);
	
	var _SliderNav = __webpack_require__(28);
	
	var _SliderNav2 = _interopRequireDefault(_SliderNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      carousels: [],
	      navs: {
	        name: '',
	        litpic: '',
	        pic: '',
	        url: '',
	        style: 0
	      },
	      slideLeft: 0,
	      offsetTop: 150,
	      drap: false,
	      clists: [{
	        name: '直播',
	        id: 'zhibo'
	      }, {
	        name: '动画',
	        id: 'donghua'
	      }, {
	        name: '番剧',
	        id: 'fanjv'
	      }, {
	        name: '国创',
	        id: 'guochuang'
	      }, {
	        name: '音乐',
	        id: 'yinyue'
	      }, {
	        name: '舞蹈',
	        id: 'wudao'
	      }, {
	        name: '游戏',
	        id: 'youxi'
	      }, {
	        name: '科技',
	        id: 'keji'
	      }, {
	        name: '生活',
	        id: 'shenghuo'
	      }, {
	        name: '鬼畜',
	        id: 'guichu'
	      }, {
	        name: '时尚',
	        id: 'shishang'
	      }, {
	        name: '广告',
	        id: 'guanggao'
	      }, {
	        name: '娱乐',
	        id: 'yule'
	      }, {
	        name: '电影',
	        id: 'dianying'
	      }, {
	        name: 'TV剧',
	        id: 'tv'
	      }]
	    };
	  },
	
	  components: {
	    TopNav: _TopNav2.default,
	    BgNav: _BgNav2.default,
	    Mcarousel: _Mcarousel2.default,
	    Lcarousel: _Lcarousel2.default,
	    SliderNav: _SliderNav2.default
	  },
	  methods: {
	    mcarousel: function mcarousel() {
	      var _this = this;
	
	      this.$http.jsonp('https://api.bilibili.com/x/web-show/res/loc?jsonp=jsonp&pf=0&id=23').then(function (response) {
	        _this.carousels = response.body.data;
	      }, function (response) {
	        console.log('请求失败!');
	      });
	    },
	    nav: function nav() {
	      var _this2 = this;
	
	      this.$http.jsonp('https://api.bilibili.com/x/web-show/res/loc?jsonp=jsonp&pf=0&id=142').then(function (response) {
	        _this2.navs = response.body.data[0];
	      }, function (response) {
	        console.log('请求失败!');
	      });
	    },
	    placeholder: function placeholder() {
	      this.$http.jsonp('https://www.bilibili.com/widget/getSearchDefaultWords').then(function (response) {
	        console.log(response);
	      }, function (response) {
	        console.log('请求失败!');
	      });
	    },
	    updateView: function updateView() {
	      var _this3 = this;
	
	      var arr = Array.prototype.slice.call(this.$refs.navDetail.childNodes);
	      arr.forEach(function (item, index) {
	        _this3.clists[index].height = parseInt(window.getComputedStyle(item).height.replace('px', ''));
	        _this3.clists[index].top = item.offsetTop;
	      });
	    },
	    updateSlide: function updateSlide() {
	      var screenW = document.body.clientWidth;
	      var container = parseInt(window.getComputedStyle(this.$refs.container).width.replace('px', ''));
	      this.slideLeft = (screenW + container) / 2 + 10;
	    },
	    updateDrap: function updateDrap(data) {
	      this.drap = data;
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    this.mcarousel();
	
	    this.nav();
	
	    this.updateView();
	
	    this.updateSlide();
	
	    window.addEventListener('resize', function () {
	      _this4.updateSlide();
	    });
	  },
	  destroyed: function destroyed() {}
	};

/***/ },
/* 17 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 18 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 19 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 20 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 21 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 22 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 23 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* template */
	var __vue_template__ = __webpack_require__(33)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(21)
	
	/* script */
	__vue_exports__ = __webpack_require__(10)
	
	/* template */
	var __vue_template__ = __webpack_require__(37)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(20)
	
	/* script */
	__vue_exports__ = __webpack_require__(11)
	
	/* template */
	var __vue_template__ = __webpack_require__(36)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(18)
	
	/* script */
	__vue_exports__ = __webpack_require__(12)
	
	/* template */
	var __vue_template__ = __webpack_require__(34)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(22)
	
	/* script */
	__vue_exports__ = __webpack_require__(13)
	
	/* template */
	var __vue_template__ = __webpack_require__(38)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7"
	
	module.exports = __vue_exports__


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(23)
	
	/* script */
	__vue_exports__ = __webpack_require__(14)
	
	/* template */
	var __vue_template__ = __webpack_require__(39)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(19)
	
	/* script */
	__vue_exports__ = __webpack_require__(15)
	
	/* template */
	var __vue_template__ = __webpack_require__(35)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(17)
	
	/* script */
	__vue_exports__ = __webpack_require__(16)
	
	/* template */
	var __vue_template__ = __webpack_require__(32)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 32 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "content"
	  }, [_h('div', {
	    directives: [{
	      name: "show",
	      value: (drap),
	      expression: "drap"
	    }],
	    staticClass: "body-bg",
	    on: {
	      "click": function($event) {
	        drap = !drap
	      }
	    }
	  }), " ", _h('div', {
	    staticClass: "b-page-header"
	  }, [_h('topNav', {
	    attrs: {
	      "bg": navs.pic,
	      "light": navs.style
	    }
	  }), " ", _h('bgNav', {
	    attrs: {
	      "logo": navs.litpic,
	      "bg": navs.pic,
	      "title": navs.name,
	      "url": navs.url
	    }
	  })]), " ", " ", _h('SliderNav', {
	    attrs: {
	      "lists": clists,
	      "left": slideLeft,
	      "offsetTop": offsetTop,
	      "drap": drap
	    },
	    on: {
	      "updateDrap": updateDrap
	    }
	  }), " ", _h('div', {
	    staticClass: "b-page-body"
	  }, [_h('div', {
	    ref: "container",
	    staticClass: "container",
	    attrs: {
	      "id": "index-top"
	    }
	  }, [_h('div', {
	    staticClass: "b-l"
	  }, [_h('Mcarousel', {
	    attrs: {
	      "carousels": carousels
	    }
	  })]), " ", _h('div', {
	    staticClass: "b-r"
	  }, [_h('Lcarousel')])]), " ", " ", _h('section', {
	    ref: "navDetail"
	  }, [_l((clists), function(item) {
	    return _h('div', {
	      staticClass: "container b-section",
	      attrs: {
	        "id": item.id
	      }
	    }, [_h('p', [_s(item.name)])])
	  })]), " ", _m(0)])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "footer container"
	  }, [_h('a', {
	    attrs: {
	      "href": "https://github.com/xyxiao001",
	      "target": "_blank"
	    }
	  }, ["footer"]), " ", _h('a', {
	    attrs: {
	      "href": "https://github.com/xyxiao001",
	      "target": "_blank"
	    }
	  }, ["goodboy"]), " ", _h('p', ["看看超过会怎样"])])
	}}]}

/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "wrapper"
	  }, [_h('router-view')])
	}},staticRenderFns: []}

/***/ },
/* 34 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "t-carousel"
	  }, [_h('ul', {
	    staticClass: "carousel",
	    style: ({
	      'transform': 'translate3d(' + -(index * 20) + '%, 0, 0)'
	    })
	  }, [_l((carousels), function(carousel) {
	    return _h('li', [_h('a', {
	      attrs: {
	        "href": carousel.url,
	        "target": "_blank"
	      }
	    }, [_h('img', {
	      attrs: {
	        "src": carousel.pic
	      }
	    })])])
	  })]), " ", _m(0), " ", _h('ul', {
	    staticClass: "slider-bar"
	  }, [_l((carousels), function(carousel, $index) {
	    return _h('li', {
	      class: {
	        'on': $index === index
	      },
	      attrs: {
	        "bar": "bar"
	      },
	      on: {
	        "click": function($event) {
	          go($index)
	        },
	        "mouseover": end,
	        "mouseout": start
	      }
	    })
	  })]), " ", _h('div', {
	    staticClass: "s-bottom"
	  }, [_h('a', {
	    staticClass: "show-info",
	    attrs: {
	      "href": url,
	      "target": "_blank"
	    }
	  }, [_s(name)])])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('a', {
	    staticClass: "more-topic",
	    attrs: {
	      "href": "http://www.bilibili.com/topic/integrated-1.html",
	      "target": "_blank"
	    }
	  }, ["\n    更多", _h('i', {
	    staticClass: "b-icon b-icon-arrow-r"
	  })])
	}}]}

/***/ },
/* 35 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('nav', {
	    staticClass: "top-nav",
	    class: lights
	  }, [_h('div', {
	    staticClass: "bg"
	  }, [_h('div', {
	    staticClass: "bg-ma",
	    style: ({
	      'background-image': 'url(' + this.bg + ')'
	    })
	  }), " ", _m(0)]), " ", _h('div', {
	    staticClass: "nav-content"
	  }, [_h('ul', {
	    staticClass: "nav"
	  }, [_h('li', [_h('router-link', {
	    attrs: {
	      "to": {
	        path: '/'
	      },
	      "title": "主站"
	    }
	  }, ["主站"])]), " ", _h('li', [_h('router-link', {
	    attrs: {
	      "to": {
	        path: '/'
	      },
	      "title": "画友"
	    }
	  }, ["画友"])]), " ", _h('li', [_h('router-link', {
	    staticClass: "show-tag",
	    attrs: {
	      "to": {
	        path: '/'
	      },
	      "title": "游戏中心",
	      "id": "gameCenter"
	    }
	  }, ["游戏中心"]), " ", _h('div', {
	    staticClass: "show-content"
	  }, [_m(1), " ", _h('div', {
	    staticClass: "right"
	  }, [_m(2), " ", _h('div', {
	    staticClass: "all"
	  }, [_l((ranks), function(rank) {
	    return _h('a', {
	      attrs: {
	        "target": "_blank",
	        "href": rank.url
	      },
	      on: {
	        "mouseover": function($event) {
	          show(rank.img)
	        },
	        "mouseout": leave
	      }
	    }, [_h('span', [_s(rank.text)])])
	  })])]), " ", _m(3)])]), " ", _h('li', [_h('router-link', {
	    staticClass: "show-tag",
	    attrs: {
	      "to": {
	        path: '/'
	      },
	      "title": "直播",
	      "id": "online"
	    }
	  }, ["直播"]), " ", _m(4)]), " ", _h('li', [_h('router-link', {
	    attrs: {
	      "to": {
	        path: '/'
	      },
	      "title": "周边"
	    }
	  }, ["周边"])]), " ", _h('li', [_h('router-link', {
	    staticClass: "phone",
	    attrs: {
	      "to": {
	        path: '/'
	      },
	      "title": "移动端"
	    }
	  }, [_m(5), " ", _m(6)])])]), " ", _h('div', {
	    staticClass: "user-box"
	  }, [_h('ul', [_m(7), " ", _m(8), " ", _m(9), " ", _h('li', {
	    staticClass: "none"
	  }, [_h('router-link', {
	    staticClass: "i-link",
	    attrs: {
	      "to": {
	        path: '/'
	      },
	      "title": "投稿"
	    }
	  }, ["投 稿"]), " ", _m(10)])])])])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "bg-model"
	  })
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "left"
	  }, [_h('div', {
	    staticClass: "banner"
	  }, [_h('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "http://vipgift.biligame.com/"
	    }
	  }, [_h('img', {
	    attrs: {
	      "src": "http://i0.hdslb.com/bfs/game/32bbcb85fb7c344f30f46a5b30f9219243ec9740.jpg",
	      "alt": "大会员礼包"
	    }
	  }), " ", _h('span', ["大会员礼包"])])]), " ", _h('div', {
	    staticClass: "brief clearfix"
	  }, [_h('a', {
	    attrs: {
	      "target": "_blank",
	      "title": "命运-冠位指定（Fate/GO）",
	      "href": "http://acg.tv/u1Hz"
	    }
	  }, [_h('img', {
	    attrs: {
	      "src": "http://i0.hdslb.com/bfs/game/f7d4ee0877089e4079b8f0b4f5c95dd4ceba512a.png",
	      "alt": "命运-冠位指定（Fate/GO）"
	    }
	  }), " ", _h('span', ["命运-冠位指定（Fate/GO）"])]), " ", _h('a', {
	    attrs: {
	      "target": "_blank",
	      "title": "如果的世界",
	      "href": "http://rgdsj.biligame.com/"
	    }
	  }, [_h('img', {
	    attrs: {
	      "src": "http://i0.hdslb.com/bfs/game/b8132ed0de34f1cd53bab5e2a40c9f48c01542fb.png",
	      "alt": "如果的世界"
	    }
	  }), " ", _h('span', ["如果的世界"])]), " ", _h('a', {
	    attrs: {
	      "target": "_blank",
	      "title": "阴阳师",
	      "href": "http://yys.biligame.com/"
	    }
	  }, [_h('img', {
	    attrs: {
	      "src": "http://i0.hdslb.com/bfs/game/3b205675d44bbd90e6ea46d4baec9674bda6e642.png",
	      "alt": "阴阳师"
	    }
	  }), " ", _h('span', ["阴阳师"])])])])
	}},function (){with(this) {
	  return _h('a', {
	    staticClass: "bbs",
	    attrs: {
	      "target": "_blank",
	      "href": "http://bbs.biligame.com"
	    }
	  }, ["游戏论坛"])
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "imgdiv",
	    attrs: {
	      "style": "background-repeat: no-repeat;"
	    }
	  })
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "show-content live-box"
	  }, [_h('div', {
	    staticClass: "live-lf"
	  }, [_h('p', {
	    staticClass: "title"
	  }, ["热门直播:"]), " ", _h('div', {
	    staticClass: "lf-list"
	  }, [_h('a', {
	    staticClass: "lf-item",
	    attrs: {
	      "href": "http://live.bilibili.com/1169523",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    attrs: {
	      "src": "http://i0.hdslb.com/bfs/face/0a3635d76b2dcb6379dc84d27b03dbc892123c93.jpg"
	    }
	  }), _h('i', ["LIVE"]), _h('p', ["番茄君也是水果"])]), " ", _h('a', {
	    staticClass: "lf-item",
	    attrs: {
	      "href": "http://live.bilibili.com/291263",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    attrs: {
	      "src": "http://i0.hdslb.com/bfs/face/fa6f9fabb7bdf08f413fe6d0a99ad74bbadfab4e.jpg"
	    }
	  }), _h('i', ["LIVE"]), _h('p', ["许仙大官人丶"])]), " ", _h('a', {
	    staticClass: "lf-item",
	    attrs: {
	      "href": "http://live.bilibili.com/191313",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    attrs: {
	      "src": "http://i0.hdslb.com/bfs/face/9c6cda4e0d0fcbe54817a4f0b455b15e1895b537.jpg"
	    }
	  }), _h('i', ["LIVE"]), _h('p', ["蠢棉"])]), " ", _h('a', {
	    staticClass: "lf-item",
	    attrs: {
	      "href": "http://live.bilibili.com/18057",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    attrs: {
	      "src": "http://i1.hdslb.com/bfs/face/6da3e04dcb01237af3b9b446d39121e67009b1f6.jpg"
	    }
	  }), _h('i', ["LIVE"]), _h('p', ["旋转的亚索"])]), " ", _h('a', {
	    staticClass: "lf-item",
	    attrs: {
	      "href": "http://live.bilibili.com/24838",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    attrs: {
	      "src": "http://i1.hdslb.com/bfs/face/7d6b5a8952d6b6162a3777634d1e432ebfbfc216.jpg"
	    }
	  }), _h('i', ["LIVE"]), _h('p', ["二五八万KT"])]), " ", _h('a', {
	    staticClass: "lf-item",
	    attrs: {
	      "href": "http://live.bilibili.com/272849",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    attrs: {
	      "src": "http://i2.hdslb.com/bfs/face/291b06d44fb15321a629239f945a4aa4ac45a792.jpg"
	    }
	  }), _h('i', ["LIVE"]), _h('p', ["猴叔w"])])])]), " ", _h('div', {
	    staticClass: "live-lr"
	  }, [_h('p', {
	    staticClass: "title title2"
	  }, ["热门活动:"]), " ", _h('div', {
	    staticClass: "banner"
	  }, [_h('a', {
	    attrs: {
	      "href": "http://live.bilibili.com/hd/aki2016",
	      "target": "_blank",
	      "title": "红叶祭二阶开放啦"
	    }
	  }, [_h('img', {
	    attrs: {
	      "src": "http://i0.hdslb.com/bfs/live/46cb3071202cd942602692071d61f07143e5fd34.jpg"
	    }
	  })]), " ", _h('a', {
	    attrs: {
	      "href": "http://live.bilibili.com/hd/momiji",
	      "target": "_blank",
	      "title": "红叶祭三阶-miss 椛总选举"
	    }
	  }, [_h('img', {
	    attrs: {
	      "src": "http://i0.hdslb.com/bfs/live/71e0b3cb7cde56ddd0da73860016ad690c4e01b8.jpg"
	    }
	  })])])])])
	}},function (){with(this) {
	  return _h('span', ["移动端"])
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "mobile-p-box"
	  }, [_h('div', {
	    staticClass: "mobile-p-qrcode"
	  })])
	}},function (){with(this) {
	  return _h('li', [_h('a', {
	    attrs: {
	      "href": "https://passport.bilibili.com/login",
	      "target": "_blank",
	      "title": "登录"
	    }
	  }, ["登录"])])
	}},function (){with(this) {
	  return _h('i', {
	    staticClass: "s-line"
	  })
	}},function (){with(this) {
	  return _h('li', [_h('a', {
	    attrs: {
	      "href": "https://passport.bilibili.com/register/phone",
	      "target": "_blank",
	      "title": "注册"
	    }
	  }, ["注册"])])
	}},function (){with(this) {
	  return _h('ul', {
	    staticClass: "s-menu"
	  }, [_h('li', [_h('a', {
	    attrs: {
	      "href": "http://member.bilibili.com/v/video/submit.html",
	      "target": "_blank"
	    }
	  }, [_h('i', {
	    staticClass: "b-icon b-icon-vp"
	  }), " ", _h('span', ["视频投稿"])])]), " ", _h('li', [_h('a', {
	    attrs: {
	      "href": "http://member.bilibili.com/v/#!/article",
	      "target": "_blank"
	    }
	  }, [_h('i', {
	    staticClass: "b-icon b-icon-vm"
	  }), " ", _h('span', ["投稿管理"])])]), " ", _h('li', [_h('a', {
	    attrs: {
	      "href": "http://member.bilibili.com/v/video/submit.html",
	      "target": "_blank"
	    }
	  }, [_h('i', {
	    staticClass: "b-icon b-icon-vc"
	  }), " ", _h('span', ["创作中心"])])])])
	}}]}

/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "l-carousel"
	  }, [_h('ul', [_l((lists[now]), function(list) {
	    return _h('li', [_h('div', {
	      staticClass: "v-item"
	    }, [_h('a', {
	      attrs: {
	        "href": list.url,
	        "target": "_blank",
	        "title": list.title
	      }
	    }, [_m(0), " ", _m(1), " ", _h('div', {
	      staticClass: "preview"
	    }, [_h('img', {
	      attrs: {
	        "src": list.img,
	        "alt": list.title
	      }
	    })]), " ", _m(2), " ", _m(3), " ", _h('div', {
	      staticClass: "info"
	    }, [_h('div', {
	      staticClass: "t"
	    }, [_s(list.title)]), " ", _h('p', {
	      staticClass: "up"
	    }, [_s(list.up)]), " ", _h('p', {
	      staticClass: "play"
	    }, [_s(list.play)])])])])])
	  })]), " ", _h('div', {
	    staticClass: "prev",
	    on: {
	      "click": function($event) {
	        now = now > 0 ? now -= 1 : now = 2
	      }
	    }
	  }, [_s(this.pre = this.now === 0 ? '昨日' : this.now === 1 ? '三日' : '一周')]), " ", _h('div', {
	    staticClass: "next",
	    on: {
	      "click": function($event) {
	        now = now < 2 ? now += 1 : now = 0
	      }
	    }
	  }, [_s(this.next = this.now === 0 ? '一周' : this.now === 1 ? '昨日' : '三日')])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "medal"
	  })
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "original"
	  })
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "mask"
	  })
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "play-icon"
	  })
	}}]}

/***/ },
/* 37 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "header",
	    style: ({
	      'background-image': 'url(' + this.bg + ')'
	    })
	  }, [_h('div', {
	    staticClass: "h-content"
	  }, [_h('div', {
	    staticClass: "h-info"
	  }, [_h('router-link', {
	    staticClass: "logo",
	    style: ({
	      'background-image': 'url(' + this.logo + ')'
	    }),
	    attrs: {
	      "to": {
	        path: '/'
	      }
	    }
	  }), " ", _h('a', {
	    staticClass: "banner-title",
	    attrs: {
	      "href": url,
	      "target": "_blank"
	    }
	  }, [_s(title)]), " ", _m(0)])]), " ", _h('div', {
	    staticClass: "h-menu"
	  }, [_h('div', {
	    staticClass: "menu-wrapper"
	  }, [_h('ul', [_h('li', {
	    staticClass: "index-menu"
	  }, [_h('router-link', {
	    staticClass: "dashboard",
	    attrs: {
	      "to": {
	        path: '/'
	      }
	    }
	  }, [_m(1)])]), " ", _l((menus), function(menu) {
	    return _h('li', {
	      staticClass: "other-menu"
	    }, [_h('router-link', {
	      attrs: {
	        "to": {
	          path: menu.url
	        }
	      }
	    }, [_h('div', {
	      staticClass: "menu-num"
	    }, [_h('span', {
	      staticClass: "num"
	    }, [_s(menu.num)])]), " ", _h('span', {
	      staticClass: "menu-text"
	    }, [_s(menu.text)])]), " ", _h('smallMenu', {
	      attrs: {
	        "items": menu.items
	      }
	    })])
	  }), " ", _h('li', {
	    staticClass: "last-menu"
	  }, [_h('router-link', {
	    staticClass: "square",
	    attrs: {
	      "to": {
	        path: '/'
	      }
	    }
	  }, [_m(2)]), " ", _m(3)]), " ", _h('li', {
	    staticClass: "last-menu"
	  }, [_h('router-link', {
	    staticClass: "live",
	    attrs: {
	      "to": {
	        path: '/'
	      }
	    }
	  }, [_m(4)]), " ", _h('smallMenu', {
	    attrs: {
	      "items": onlines
	    }
	  })]), " ", _m(5)]), " ", _m(6)])])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "search"
	  }, [_h('a', {
	    staticClass: "link-ranking",
	    attrs: {
	      "href": "http://www.bilibili.com/ranking",
	      "target": "_blank"
	    }
	  }, [_h('span', ["排行榜"])]), " ", _h('form', [_h('input', {
	    attrs: {
	      "type": "text",
	      "name": "search",
	      "autocomplete": "off",
	      "placeholder": "如何在MC中还原《三体》原著"
	    }
	  }), " ", _h('button', {
	    attrs: {
	      "type": "button"
	    }
	  })])])
	}},function (){with(this) {
	  return _h('span', {
	    staticClass: "menu-text"
	  }, ["首页"])
	}},function (){with(this) {
	  return _h('span', ["广场"])
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "second-menu"
	  }, [_h('ul', [_h('li', [_h('a', {
	    attrs: {
	      "href": "http://activity.bilibili.com",
	      "target": "_blank"
	    }
	  }, [_h('i', {
	    staticClass: "i-activity"
	  }), " ", _h('b', ["活动中心"])])]), " ", _h('li', [_h('a', {
	    attrs: {
	      "href": "http://game.bilibili.com",
	      "target": "_blank"
	    }
	  }, [_h('i', {
	    staticClass: "i-game"
	  }), " ", _h('b', ["游戏中心"])])]), " ", _h('li', [_h('a', {
	    attrs: {
	      "href": "http://h.bilibili.com",
	      "target": "_blank"
	    }
	  }, [_h('i', {
	    staticClass: "i-h"
	  }), " ", _h('b', ["画友"])])]), " ", _h('li', [_h('a', {
	    attrs: {
	      "href": "http://www.bilibili.com/mango",
	      "target": "_blank"
	    }
	  }, [_h('i', {
	    staticClass: "i-m"
	  }), " ", _h('b', ["芒果TV"])])])]), " ", _h('div', {
	    staticClass: "s-right"
	  }, [_h('div', {
	    staticClass: "item"
	  }, [_h('a', {
	    attrs: {
	      "href": "http://www.bilibili.com/event",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    attrs: {
	      "src": "http://i0.hdslb.com/group1/M00/B7/C6/oYYBAFefJyWAdVAcAAD9KmVEAFw381.jpg"
	    }
	  })])])])])
	}},function (){with(this) {
	  return _h('span', ["直播"])
	}},function (){with(this) {
	  return _h('li', {
	    staticClass: "last-menu"
	  }, [_h('a', {
	    staticClass: "black-house",
	    attrs: {
	      "href": "//www.bilibili.com/blackroom",
	      "target": "_blank"
	    }
	  }, [_h('span', ["小黑屋"])])])
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "right-menu"
	  }, [_h('img', {
	    attrs: {
	      "src": "http://i0.hdslb.com/icon/575cd42b00dbd63236116cb56ae44641.gif",
	      "alt": "动起来"
	    }
	  })])
	}}]}

/***/ },
/* 38 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "index-nav",
	    class: {
	      'draping': drap
	    },
	    style: ({
	      'top': navTop + 'px',
	      'left': left + 'px'
	    })
	  }, [_h('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(drap) ? _h('span', [_m(0), " ", _m(1)]) : _e()]), " ", _h('div', {
	    staticClass: "nav-list"
	  }, [_l((lists), function(item, $index) {
	    return _h('div', {
	      staticClass: "nav-item",
	      class: {
	        'activity': $index === nowItem
	      },
	      on: {
	        "click": function($event) {
	          navClick(item.top - offsetTop, $index)
	        }
	      }
	    }, ["\n      " + _s(item.name) + "\n    "])
	  }), " ", _h('div', {
	    staticClass: "nav-item choose",
	    style: ({
	      'transform': 'translate3d(0, ' + (nowItem + 1) * 32 + 'px, 0)'
	    })
	  })]), " ", _h('div', {
	    staticClass: "nav-item rank",
	    attrs: {
	      "title": "排序"
	    },
	    on: {
	      "click": changeDraps
	    }
	  }, [_m(2), _m(3)]), " ", _h('div', {
	    staticClass: "gotop"
	  }, [_m(4), _h('div', {
	    staticClass: "btn_gotop",
	    attrs: {
	      "title": "返回顶部"
	    },
	    on: {
	      "click": function($event) {
	        goScroll(0)
	      }
	    }
	  })])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "nav-bg"
	  })
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "nav-tip"
	  })
	}},function (){with(this) {
	  return _h('i', {
	    staticClass: "n-icon-sort"
	  })
	}},function (){with(this) {
	  return _h('p', ["排序"])
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "s-line"
	  })
	}}]}

/***/ },
/* 39 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('ul', {
	    staticClass: "small-menu"
	  }, [_l((items), function(item) {
	    return _h('li', [_h('router-link', {
	      attrs: {
	        "to": {
	          path: item.url
	        }
	      }
	    }, [_h('span', [_s(item.text), _m(0)])])])
	  })])
	}},staticRenderFns: [function (){with(this) {
	  return _h('em')
	}}]}

/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.js
 **/